// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2CYhL","question":"Question_question__Dk4BQ","description":"Question_description__XZZ57"};